import { render, staticRenderFns } from "./FormSetBuzzer.vue?vue&type=template&id=0d087572"
import script from "./FormSetBuzzer.vue?vue&type=script&lang=js"
export * from "./FormSetBuzzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports